export default __webpack_public_path__ + "static/media/redo.f645f961.svg";